import { render, staticRenderFns } from "./StatusBatchUpdateDialog.vue?vue&type=template&id=11a4d8c2"
import script from "./StatusBatchUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./StatusBatchUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports